import { BaseModal, ModalResultType, ModalOptions } from "../../modal/index";
import { Template, LazyTemplate } from "../../template/index";

export default class MessageModal extends BaseModal
{
    public template = Template.lazy('/core/modals/message/index.html');

    public get defaults(): ModalOptions
    {
        return {
            title: this.pgettext('Title', 'Confirmation')
        }
    }

    public beforeRender(): PromiseLike<void>
    {
        return super.beforeRender();
    }

    public onOkButtonClick(e: MouseEvent)
    {
        this.close(ModalResultType.OK);
    }
}